Object.defineProperty(exports,"__esModule",{value:true});exports.mapper=exports.isRelevantTopic=exports.deserializer=undefined;var _state_pb=require('./protoModels/mti/store/puck/state_pb');
var _rule_state_pb=require('./protoModels/mti/rule_state_pb');
var _state_pb2=require('./protoModels/mti/store/lock/state_pb');
var _state_pb3=require('./protoModels/mti/store/alarm_module/state_pb');
var _state_pb4=require('./protoModels/mti/store/core_iii/state_pb');
var _state_pb5=require('./protoModels/mti/store/secure_plug/state_pb');
var _state_pb6=require('./protoModels/mti/store/ram/state_pb');
var _state_pb7=require('./protoModels/mti/store/fm_20/state_pb');
var _state_pb8=require('./protoModels/mti/store/proximity_puck/state_pb');
var _state_pb9=require('./protoModels/mti/store/nxdi/state_pb');
var _resource_updated_pb=require('./protoModels/mti/resource_updated_pb');
var _health_state_pb=require('./protoModels/mti/health_state_pb');
var _physical_key_state_pb=require('./protoModels/mti/physical_key_state_pb');

var _mapHealthState=require('./mappers/mapHealthState');var _mapHealthState2=_interopRequireDefault(_mapHealthState);
var _mapResourceUpdate=require('./mappers/mapResourceUpdate');var _mapResourceUpdate2=_interopRequireDefault(_mapResourceUpdate);
var _mapPuckStateChange=require('./mappers/mapPuckStateChange');
var _mapCXFlexState=require('./mappers/mapCXFlexState');
var _mapSecurePlugState=require('./mappers/mapSecurePlugState');
var _mapRamState=require('./mappers/mapRamState');
var _mapLockStateChange=require('./mappers/mapLockStateChange');
var _mapFM20State=require('./mappers/mapFM20State');
var _mapProximityPuckStateChange=require('./mappers/mapProximityPuckStateChange');
var _mapNXDIPuckStateChange=require('./mappers/mapNXDIPuckStateChange');
var _mapPositionRuleChange=require('./mappers/mapPositionRuleChange');



var _mapAlarmModule=require('./mappers/mapAlarmModule');
var _mapKeyState=require('./mappers/mapKeyState');var _mapKeyState2=_interopRequireDefault(_mapKeyState);
var _clearFromIds=require('./clearFromIds');var _clearFromIds2=_interopRequireDefault(_clearFromIds);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}






var deserializer=exports.deserializer=function deserializer(topic){
var cleared=(0,_clearFromIds2.default)(topic);
var row=TopicLookupTable[cleared];
if(row){
return row.deserializer;
}
return null;
};





var isRelevantTopic=exports.isRelevantTopic=function isRelevantTopic(topic){
var cleared=(0,_clearFromIds2.default)(topic);
return TopicLookupTable[cleared]!=null;
};





var mapper=exports.mapper=function mapper(topic){
var cleared=(0,_clearFromIds2.default)(topic);
var row=TopicLookupTable[cleared];
if(row){
return function(message){


message._mqttRawTopic=topic;
return row.mapper(message);
};
}

return null;
};






var lookupValue=function lookupValue(deserializer,mapper){return{
deserializer:deserializer,
mapper:mapper};};







var TopicLookupTable={
'/store/fix/pos/rule/state':lookupValue(
_rule_state_pb.RuleState.deserializeBinary,
_mapPositionRuleChange.mapPositionRuleChange),

'/store/fix/rule/state':lookupValue(
_rule_state_pb.RuleState.deserializeBinary,
_mapPositionRuleChange.mapFixtureRuleChange),

'/store/puck/state':lookupValue(
_state_pb.State.deserializeBinary,
_mapPuckStateChange.mapPuckStateChange),

'/store/core_iii/state':lookupValue(
_state_pb4.State.deserializeBinary,
_mapCXFlexState.mapCXFlexStateChange),

'/store/secure_plug/state':lookupValue(
_state_pb5.State.deserializeBinary,
_mapSecurePlugState.mapSecurePlugStateChange),

'/store/ram/state':lookupValue(
_state_pb6.State.deserializeBinary,
_mapRamState.mapRamStateChange),

'/store/alarm_module/state':lookupValue(
_state_pb3.State.deserializeBinary,
_mapAlarmModule.mapAlarmModuleStateChange),

'/store/lock/state':lookupValue(
_state_pb2.State.deserializeBinary,
_mapLockStateChange.mapLockStateChange),

'/store/fm_20/state':lookupValue(
_state_pb7.State.deserializeBinary,
_mapFM20State.mapFM20StateChange),

'/store/proximity_puck/state':lookupValue(
_state_pb8.State.deserializeBinary,
_mapProximityPuckStateChange.mapProximityPuckStateChange),

'/store/nxdi/state':lookupValue(
_state_pb9.State.deserializeBinary,
_mapNXDIPuckStateChange.mapNXDIPuckStateChange),



'/store/sd/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/base/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/base_v2/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/proximity_base/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/nxdi_base/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/puck/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/puck_v2/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/proximity_puck/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/nxdi/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/lock/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/alarm_module/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/secure_plug/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/core_iii/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/ram/health':lookupValue(
_health_state_pb.HealthState.deserializeBinary,
_mapHealthState2.default),

'/store/updated/store':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/sp':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/sd':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/fix':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/pos':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/pos_rule':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/fix_rule':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/store_rule':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/rule':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/updated/prod':lookupValue(
_resource_updated_pb.ResourceUpdated.deserializeBinary,
_mapResourceUpdate2.default),

'/store/keys':lookupValue(_physical_key_state_pb.PhysicalKeyState.deserializeBinary,_mapKeyState2.default)};